module.exports = __webpack_public_path__ + "img/img-5.450e3cb9.webp";